import {
  GET_LIST_DIMENSIONS_WATCHER,
  GET_LIST_DIMENSIONS_SUCCESS,
  GET_LIST_DIMENSIONS_FAILED,
} from "./constants"

export function getListDimensionsWatcher(payload) {
  return {
    type: GET_LIST_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getListDimensionsSuccess(payload) {
  return {
    type: GET_LIST_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getListDimensionsFailed() {
  return { type: GET_LIST_DIMENSIONS_FAILED }
}
